import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Row, Col, Card } from "antd";

import CardOrganisationProfile from "../CardOrganisationProfile";
import { formatPlainDate } from "../../../helpers/utils";

import "./OrganisationProfileView.scss";

export default function OrganisationProfileView({
  overflow = "auto",
  showCancelSubscription = true,
  organisationProfileData,
}) {
  const generateArrayForCard = (cardHeading) => {
    const {
      critical_POC_email,
      critical_POC_name,
      critical_POC_phone,
      critical_service,
      facilitator_name,
      facilitator_phone,
      facilitator_email,
      sector,
      date_of_CRR,
      location_city,
      location_state,
      organization_type,
      organization_name,
    } = organisationProfileData;
    const returnArray = [];

    switch (cardHeading) {
      case "facilitator":
        const facilitatorKeys = [
          "Name",
          "Phone",
          "Email ID",
          "Date of Cyber Resilience Review",
          "Name of Organization",
          "Sector",
          "Organization Type",
          "Critical Service",
        ];
        const facilitatorValues = [
          facilitator_name,
          facilitator_phone,
          facilitator_email,
          formatPlainDate(date_of_CRR),
          organization_name,
          sector,
          organization_type,
          critical_service,
        ];

        for (let i = 0; i < facilitatorKeys.length; i++) {
          returnArray.push({
            key: facilitatorKeys[i],
            value: facilitatorValues[i],
          });
        }

        return returnArray;

      case "location":
        const locationKeys = ["City", "State"];
        const locationValues = [location_city, location_state];

        for (let i = 0; i < locationKeys.length; i++) {
          returnArray.push({ key: locationKeys[i], value: locationValues[i] });
        }

        return returnArray;

      case "criticalPOC":
        const criticalPOCKeys = ["Name", "Phone", "Email ID"];
        const criticalPOCValues = [
          critical_POC_name,
          critical_POC_phone,
          critical_POC_email,
        ];

        for (let i = 0; i < criticalPOCKeys.length; i++) {
          returnArray.push({
            key: criticalPOCKeys[i],
            value: criticalPOCValues[i],
          });
        }

        return returnArray;

      default:
        break;
    }
  };

  return (
    <>
      <div className="organisation-profile-content" style={{ overflow }}>
        <CardOrganisationProfile
          cardHeading="Facilitator"
          keyValueArray={() => generateArrayForCard("facilitator")}
        />

        <CardOrganisationProfile
          cardHeading="Physical Location"
          keyValueArray={() => generateArrayForCard("location")}
        />

        <CardOrganisationProfile
          cardHeading="Critical Service Point of Contact"
          keyValueArray={() => generateArrayForCard("criticalPOC")}
        />

        <Card
          style={{
            marginTop: "15px",
            width: "100%",
            borderRadius: "10px",
            boxShadow: "0 10px 20px 0 rgba(113, 113, 113, 0.06)",
            border: "solid 1px #F8F8F6",
            backgroundColor: "#fff",
          }}
        >
          <h2 className="card-heading">Subscription Details</h2>
          <Row>
            <Col className="gutter-row" span={6}>
              <div className="card-key">Subscription Plan</div>
              <div className="card-value">Blank</div>
            </Col>
            {showCancelSubscription && (
              <Col className="gutter-row" span={6}>
                <Button
                  size="large"
                  style={{
                    borderRadius: "8px",
                    border: "solid 2px #e02020",
                    backgroundColor: "#fff",
                    color: "#e02020",
                    fontFamily: "Geist, sans-serif",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    lineHeight: "normal",
                    margin: "33px 0 0 47px",
                  }}
                >
                  CANCEL SUBSCRIPTION
                </Button>
              </Col>
            )}
          </Row>
        </Card>
      </div>
    </>
  );
}
